module.exports = __webpack_public_path__ + "static/media/BRA.ea5e1959.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/BRA.JPG
// module id = 1712
// module chunks = 1